import React from 'react';

import { MediaElement } from 'editor/src/store/design/types';
import { OutsideSheetWarning } from 'editor/src/store/editorModules/warnings/types';

import AbstractWarningItem from './AbstractWarningItem';

interface Props {
  warning: OutsideSheetWarning;
  element: MediaElement;
  selected: boolean;
}

// GAPI-53417: no fix action here on purpose — the buyer decides whether to move the copy
// or make it smaller, and Auto nest already exists for laying the whole sheet out again.
function OutsideSheetWarningItem({ warning, element, selected }: Props) {
  return (
    <AbstractWarningItem
      warning={warning}
      element={element}
      selected={selected}
      // TODO: Lokalino
      title="Artwork is off the sheet"
    >
      {/* TODO: Lokalino */}
      Part of this artwork is outside the sheet and will not be printed. Move it or make it smaller so it sits fully
      inside the sheet.
    </AbstractWarningItem>
  );
}

export default React.memo(OutsideSheetWarningItem);
